import React from 'react'
import { getAPIFullUrl, getAxiosConfig, getUserAPIToken } from './risapi';
import { risapi } from './risapi';
import { convertJsonToFormData } from '../commonfunctions';



export const createUser =  async (newUser,callback) => {
  
    try {
        // let axiosConfig = {
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Accept': 'application/json',
        //         "Authorization": "Bearer " + getAxiosConfig()
        //     }
        // };
        console.log("new user",newUser);
        
        var headers = getAxiosConfig();
        headers.headers['Content-Type'] = 'multipart/form-data';
        console.log("headers",headers);
        
        var formData = convertJsonToFormData(newUser);
        const response = await risapi.post('/api/users', formData,headers);

        console.log("create User Response",response);
        
        if (response.status === 201) {
            callback(response.data);
        }
    } catch (error) {
        callback(error);
    }
}
export const UpdateUser =  async (editUser,callback) => {
  
    try {
        // let axiosConfig = {
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Accept': 'application/json',
        //         "Authorization": "Bearer " + getAxiosConfig()
        //     }
        // };
         var headers = getAxiosConfig();
        headers.headers['Content-Type'] = 'multipart/form-data';
        console.log("headers",headers);
        
        var formData = convertJsonToFormData(editUser);

         formData.append('_method', 'put');

        

        const response = await risapi.post('/api/users/'+editUser.id, formData,headers);

        console.log(response);
        
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        callback(error);
    }
}
export const destroyUser =  async (deleteUser,callback) => {
  
    try {
        // let axiosConfig = {
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Accept': 'application/json',
        //         "Authorization": "Bearer " + getAxiosConfig()
        //     }
        // };
        deleteUser._method = 'delete';
        const response = await risapi.post('/api/users/'+deleteUser.id, deleteUser,getAxiosConfig());

        console.log(response);
        
        if (response.status === 204) {
            callback({user:deleteUser});
        }
    } catch (error) {
        callback(error);
    }
}

export const getUsers = async(filterParameters,callback)=>{
    try {
        // let axiosConfig = {
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Accept': 'application/json',
        //         "Authorization": "Bearer " + getAxiosConfig()
        //     }
        // };
        
        //         "Authorization": "Bearer " + getAxiosConfig()
        const response = await risapi.get(getAPIFullUrl('/api/users', filterParameters),getAxiosConfig());

            console.log("getdistrict response",response);
            
        if (response.status === 200) {
            callback(response.data);
        }
    
    } catch (errorResponse) {

        if(errorResponse.status == 403)
        {
            alert("Permission Denied");

        }
        else
        {
            callback(errorResponse);

        }

    }
}

export const fetchUser = async(districtId,callback)=>{
    try {
     
        const response = await risapi.get('/api/users/'+districtId,getAxiosConfig());


        if (response.status === 200) {
            callback(response.data);
        }
    
    } catch (errorResponse) {

        if(errorResponse.status == 403)
        {
            alert("Permission Denied");

        }
        else
        {
            callback(errorResponse);

        }

    }
}

export const destroyUsersMultiple =  async (ids,callback) => {
  
    try {
     
        var sendData = {};
        sendData.ids = ids;
        sendData._method = 'delete';
        const response = await risapi.post('/api/users/delete/multiple',sendData,getAxiosConfig());

        console.log("delete multiple response",response);
        
        if (response.status === 204) {
            callback({user:ids});
        }
    } catch (error) {
        callback(error);
    }
}

export const getAuthUserPersonalInformations =  async (callback) => {
  
    try {
     
        const response = await risapi.get('/api/users/personal_information',getAxiosConfig());    
        console.log("getAuthUserPersonalInformations response",response);
        
        if (response.status === 200) {
            callback(response);
        }
    } catch (error) {
        callback(error);
    }

}
 export const getAuthUserNotificationSettings =  async (callback) => {
  
    try {
     
        const response = await risapi.get('/api/users/notification_settings',getAxiosConfig());    
        console.log("getAuthUserNotificationSettings response",response);
        
        if (response.status === 200) {
            callback(response);
        }
    } catch (error) {
        callback(error);
    }
}

export const updateProfileSettings =  async (userInfo,callback) => {
  
    try {
      
         var headers = getAxiosConfig();
        headers.headers['Content-Type'] = 'multipart/form-data';
        console.log("headers",headers);
        
        var formData = convertJsonToFormData(userInfo);

         formData.append('_method', 'put');

        

        const response = await risapi.post('/api/users/profile_settings', formData,headers);

        console.log(response);
            callback(response);
        
    } catch (error) {
        callback(error);
    }
}

export const updateNotificationSettings =  async (userNotificationSettings,callback) => {
  
    try {
      console.log("userNotificationSettings before",userNotificationSettings);
      
         var headers = getAxiosConfig();
        headers.headers['Content-Type'] = 'multipart/form-data';
        console.log("headers",headers);
        
        var formData = convertJsonToFormData(userNotificationSettings);

         formData.append('_method', 'put');

        

        const response = await risapi.post('/api/users/notification_settings', formData,headers);

        console.log('/api/users/notification_settings',response);
        callback(response);
        
        
        
    } catch (error) {
        callback(error);
    }
}       


export const updateProfilePicture =  async (imageFile,callback) => {
  
    try {
     
      
         var headers = getAxiosConfig();
        headers.headers['Content-Type'] = 'multipart/form-data';
        console.log("headers",headers);
        
        var formData = new FormData();

      
         formData.append('profile_pic',imageFile);
        const response = await risapi.post('/api/users/profile_picture_update', formData,headers);

        console.log('/api/users/profile_picture',response);
        callback(response);
        
        
        
    } catch (error) {
        console.log("error",error);
        
        callback(error);
    }
}
export const removeProfilePic =  async (callback) => {
  
    try {
     
      
         var headers = getAxiosConfig();
        headers.headers['Content-Type'] = 'multipart/form-data';
        console.log("headers",headers);
        
        var formData = new FormData();

      
         formData.append('_method', 'delete');
        const response = await risapi.post('/api/users/profile_picture_remove', formData,headers);

        console.log('/api/users/profile_picture_remove',response);
        callback(response);
        
        
        
    } catch (error) {
        console.log("error",error);
        
        callback(error);

}


}    



export const updateUserProfile = async (profileData, callback) => {
    try {
        const headers = getAxiosConfig();
        headers.headers['Content-Type'] = 'multipart/form-data';

        const formData = convertJsonToFormData(profileData);
        // Since we are using POST for a PUT operation in Laravel
        formData.append('_method', 'POST'); 

        const response = await risapi.post('/api/user/profile', formData, headers);

        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        callback({ error: error });
    }
};









